
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'g-spacer'

})
